import { styleToSelector } from "../../../util/style";
import HyExtAdapterInLiveRoom from "../../adapters/HyExtAdapterInLiveRoom";
import HyExtEndpointModule from "../HyExtEndpointModule";
import drag from '../../../util/drag'
import { ExtAdapter, ShowFlag } from "@hyext-inner/ext-web-comp";

const instances:Array<HyExtWebVideoComEndpointModule> = []

export default class HyExtWebVideoComEndpointModule extends HyExtEndpointModule {
  style:any
  selector:any
  iconStyle:any
  $popup:any
  showed:boolean
  constructor(extMain:MidExtQuery.ExtMain, extEndpoint:MidExtQuery.ExtComEndpoint, adapter:ExtAdapter) {
    super(extMain, extEndpoint, adapter)
    instances.push(this)
  }
  // 业务接口
  showActivityBadge(_:any, adapter:ExtAdapter):Promise<void> {
    const key = this.getKey()
    return (adapter as HyExtAdapterInLiveRoom).showDiyBadge(key, 1).then(() => {
      if (this.$popup.is(':visible')) {
        setTimeout(() => {
          (adapter as HyExtAdapterInLiveRoom).showDiyBadge(key, 0)
        }, 5000)
      }
    })
  }
  // 重载接口
  async showUsingUnpublishConfirm(adapter:ExtAdapter):Promise<Boolean> {
    this.logger.info('showUsingUnpublishConfirm')
    this.$popup.find(this.selector.jqLoading).hide()
    const ret = await super.showUsingUnpublishConfirm(adapter)
    this.logger.info('showUsingUnpublishConfirm', { ret })
    if (ret) {
      this.$popup.find(this.selector.jqLoading).css('visibility', 'visible').show()
      this.$popup.find(this.selector.jqDeny).hide()
      return Promise.resolve(true)
    } else {
      this.logger.info('用户拒绝使用')
      this.$popup.find(this.selector.jqLoading).hide()
      this.$popup.find(this.selector.jqDeny).css('visibility', 'visible').show()
      return new Promise<boolean>(resolve => {
        this.$popup.find(this.selector.jqActivate).one('click', () => {
          this.$popup.find(this.selector.jqLoading).css('visibility', 'visible').show()
          this.$popup.find(this.selector.jqDeny).hide()
          resolve(true)
        })
      })
    }
  }
  // 实现抽象接口
  initEndpoint(adapter:ExtAdapter): Promise<void> {
    const hyExtAdpater = adapter as HyExtAdapterInLiveRoom
    // 引入样式
    this.style = require('@/sass/panel.scss')
    this.selector = styleToSelector(this.style)
    this.iconStyle = require('@/sass/icon.scss')
    // 构建html模版
    this.$popup = $(require('@/tpl/panel.html')({
      style: this.style,
      iconStyle: this.iconStyle,
      title: this.extMain.extName
    })).on('click', this.selector.jqClose, () => {
      this.hidePanel(adapter)
    }).hide()
    // 检查是否有自定义宽高
    if (this.extEndpoint.typeAuthority) {
      let { width, height } = this.extEndpoint.typeAuthority
      if (!isNaN(width) && width) {
        width = width - width % 2
        this.$popup.css({ width })
      }
      if (!isNaN(height) && height) {
        height = height - height % 2
        this.$popup.css({ height })
      }
    }
    // 加载
    this.$popup.find('section').append(this.extFrame.iframe)
    $('body').append(this.$popup)
    // 设置拖动
    this.$popup.find(this.selector.jqDrag).on('mousedown', (evt:any) => {
      this.$popup.addClass(this.style.isDrag)
      drag(this.$popup, evt.originalEvent, () => {
        this.$popup.removeClass(this.style.isDrag)
      })
    })
    // 处理入口
    hyExtAdpater.onClickEntrance((message:{ id:string }) => {
      if (message.id === this.getKey()) {
        this.sys_startup_ext_interactive(adapter)
        this.extFrame.load(adapter)
        this.showPanel(adapter)
      }
    })
    return Promise.resolve()
  }
  statusNotice(extTypeIconInfo:MidExtQuery.ExtTypeIconInfo, adapter:ExtAdapter):Promise<void> {
    if (extTypeIconInfo) {
      this.extEndpoint.typeAuthority.extTypeIconInfo = extTypeIconInfo
    }
    const { showFlag, cornerMarkUrl, serverCurrentTime, countDown } = this.extEndpoint.typeAuthority.extTypeIconInfo
    this.logger.info('showFlag', { showFlag })
    if (showFlag & Number(ShowFlag.ENTRANCE)) {
      this.logger.debug('显示入口')
      this.showExtEntrance(adapter)
    } else {
      this.logger.debug('隐藏入口')
      this.hideExtEntrance(adapter)
    }
    if (showFlag & Number(ShowFlag.PANEL)) {
      this.logger.debug('显示面板')
      this.emit('postInitResolved')
      this.showPanel(adapter)
    }
    return Promise.resolve()
  }
  postInit(adapter:ExtAdapter) {
    const hyExtAdpater = adapter as HyExtAdapterInLiveRoom
    this.$popup.find(this.selector.jqLoading).css('visibility', 'visible')
    const { showFlag } = this.extEndpoint.typeAuthority.extTypeIconInfo
    if ((showFlag & ShowFlag.PANEL) || this.$popup.is(':visible')) {
      return Promise.resolve()
    } else {
      return new Promise<void>(resolve => {
        hyExtAdpater.onClickEntrance(message => {
          if (message.id === this.getKey()) {
            resolve()
          }
        })
        this.once('postInitResolved', () => resolve())
      })
    }
  }
  showEndpointPanel(adapter:ExtAdapter): Promise<void> {
    if (!this.showed) {
      this.showed = true
      if (this.loaded) {
        this.postLifeLoad(adapter)
        this.postLifeAppear(adapter)
      }
      this.$popup.css({ top: '50%', left: '50%' })
    } else {
      if (!this.$popup.is(':visible')) {
        this.postLifeEnterForeground(adapter)
        this.postLifeAppear(adapter)
      }
    }
    this.$popup.show()
    instances.forEach(instance => {
      if (instance !== this) {
        instance.hidePanel(adapter)
      }
    })
    return Promise.resolve()
  }
  hideEndpointPanel(adapter:ExtAdapter): Promise<void> {
    if (this.$popup.is(':visible')) {
      this.postLifeLeaveForeground(adapter)
      this.postLifeDisappear(adapter)
    }
    this.$popup.hide()
    return Promise.resolve()
  }
  showEndpointEntrance(adapter:ExtAdapter): Promise<void> {
    const hyExtAdpater = adapter as HyExtAdapterInLiveRoom
    const extInfo = this.getSupInitExtInfo()
    hyExtAdpater.addDiyIcon({
      ...extInfo,
      id: this.getKey(),
      icon: extInfo.extIcon,
      name: extInfo.extName,
      weight: extInfo.extConfig.weight
    })
    this.sys_pageshow_ext_list(adapter)
    return Promise.resolve()
  }
  hideEndpointEntrance(adapter:ExtAdapter): Promise<void> {
    const hyExtAdpater = adapter as HyExtAdapterInLiveRoom
    hyExtAdpater.delDiyIcon({ id: this.getKey() })
    return Promise.resolve()
  }
  ready(adapter:ExtAdapter): Promise<boolean> {
    if (!this.loaded) {
      this.$popup.find(this.selector.jqLoading).hide()
      this.$popup.find(this.selector.jqDeny).hide()
      this.loaded = true

      if (this.showed) {
        this.postLifeAppear(adapter)
      }

      return Promise.resolve(!!this.showed)
    } else {
      return Promise.resolve(false)
    }
  }
  showSupError(msg:string): Promise<void> {
    this.logger.warn('中间页面初始化失败', { msg })
    this.$popup.find(this.selector.jqLoading).hide()
    this.$popup.find(this.selector.jqDeny).find('h2').text('小程序初始化错误')
    this.$popup.find(this.selector.jqDeny).find('div').text(msg).append(', <a href=\'https://www.huya.com\' target=\'_blank\'>点击这里了解详情</a>')
    this.$popup.find(this.selector.jqDeny).css('visibility', 'visible').show()
    return Promise.resolve()
  }
  getModalContainer() {
    return Promise.resolve(this.$popup)
  }
  textNotice(tips: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  close(content: string, adapter:ExtAdapter): Promise<void> {
    this.logger.warn('显示下线提示', content)
    let msg = '当前小程序正在进行升级，已暂时下线进行维护'
    try {
      msg = JSON.parse(content).msg
    } catch (err) {
      this.logger.warn('解析内容错误', err.msg)
    }
    this.$popup.find(this.selector.jqLoading).hide()
    this.$popup.find(this.selector.jqDeny).find('h2').text(msg)
    this.$popup.find(this.selector.jqDeny).find('div').text('')
    this.$popup.find(this.selector.jqDeny).css('visibility', 'visible').show()

    this.hideExtEntrance(adapter)
    this.extFrame.destroy()
    return Promise.resolve()
  }
}